import libraryUtils from './library--utils';

const { uniqueId } = libraryUtils;

const libraryjQuery = {};
const add = libraryjQuery;
const _$ = libraryjQuery;

// Checks if an event handler is bound to an element
add.hasBoundEvent = function hasBoundEvent($elChecking, eventType, handlerPassed) {
    const eventObject = $._data($elChecking.get(0), 'events');
    const eventBound = eventObject !== undefined;
    const eventBoundArr = eventBound && eventObject[eventType];
    if (Array.isArray(eventBoundArr)) {
        const handlerOnElement = eventObject[eventType][0].handler;
        const handlerMatches = handlerOnElement.name === handlerPassed.name && true;
        return handlerMatches;
    }
    return false;
};

// Checks if an event handler is bound, if not attaches it
// Dependency:      hasBoundEvent
add.checkAndBindEvent = function checkAndBindEvent($elReceivesHandler, eventType, handler, selector) {
    const status = { handlerBound: false };
    $elReceivesHandler.each(function(index) {
        if (!_$.hasBoundEvent($(this), eventType, handler)) {
            if (selector) $(this).on(eventType, selector, handler);
            if (!selector) $(this).on(eventType, handler);
            status.handlerBound = true;
        }
    });
    return status;
};

export default libraryjQuery;

// =============================================================================
// Actual jQuery
// =============================================================================

const JF = jQuery.fn;

JF.checkIdAndSet = function(stringForId) {
    if ($(this).attr('id')) {
        return this.attr('id');
    }
    const id = stringForId === undefined ? uniqueId() : stringForId; // If they don't pass string use global method.
    $(this).attr('id', id); // Assign id
    return id; // Return Id for user's use
};

JF.updateSelection = function() {
    const elements = $(this.selector);
    this.splice(0, this.length);
    this.push.apply(this, elements);
    return this;
};

JF.isOverflowingY = function() {
    const el = this[0];
    return el.offsetHeight < el.scrollHeight;
};

JF.isOverflowingX = function() {
    const el = this[0];
    return el.offsetWidth < el.scrollWidth;
};
